import {apiUrl} from '-/firebase';

const devApiBase = () => {
    const forceProxy = process.env.REACT_APP_FORCE_EMULATOR_PROXY === 'true';
    if (typeof window !== 'undefined' && (forceProxy || !['localhost', '127.0.0.1', ''].includes(window.location.hostname))) {
        return `${window.location.origin}/__/api`;
    }
    return process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:5002';
};

export const getApiBase = () => {
    const isDev = process.env.NODE_ENV === 'development';
    const usingApiKey = process.env.REACT_APP_API_KEY;
    if (isDev && !usingApiKey) return devApiBase().replace(/\/$/, '');
    return apiUrl ? apiUrl.replace(/\/$/, '') : null;
};

export const resolveApiBase = () => {
    const isDev = process.env.NODE_ENV === 'development';
    const usingApiKey = process.env.REACT_APP_API_KEY;
    if (isDev && !usingApiKey) return `${devApiBase().replace(/\/$/, '')}/`;
    if (!apiUrl) {
        const flag = 'apiUrl_cache_bust_attempted';
        if (typeof window !== 'undefined' && window.sessionStorage && !sessionStorage.getItem(flag)) {
            sessionStorage.setItem(flag, '1');
            const url = new URL(window.location.href);
            url.searchParams.set('_cb', Date.now().toString());
            window.location.replace(url.toString());
            throw new Error('Reloading to refresh stale config cache...');
        }
        throw new Error('apiUrl must be set in the project\'s firebase-configs/*.json (surfaced as window.__FIREBASE_CONFIG__.apiUrl) to call the api');
    }
    return `${apiUrl.replace(/\/$/, '')}/`;
};
